import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { INode } from '../node.interface';
import { nodeStoreSelector } from '../node.selector';

export const nodeStreamsSelector = createCachedSelector(
  [
    path(nodeStoreSelector).list(),
    path(nodeStoreSelector).networkStatus(),
    prop<{ nodeId: INode['nodeId'] }>().nodeId(),
  ],
  (nodeList, networkStatus, nodeId) => {
    return {
      streams: nodeList.find((node) => node.nodeId === nodeId)?.streams ?? [],
      networkStatus,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ nodeId: INode['nodeId'] }>().nodeId(),
});
